import { CUSTOM_FILTER_PREFIX, CustomFilterId } from "@/config/list";
import { structureType, StructureTypeName, StructureTypeStyle } from "@/config/structureType";

export const isCustomListFilter = (id: string): id is CustomFilterId => id.startsWith(CUSTOM_FILTER_PREFIX);

export const normalizeStructureTypeLabel = (name: string) => name.replace("Dryp - ", "");

interface GetStructureTypeByName extends StructureTypeStyle {
	id: Dryp.StructureTypeId;
}

export function getStructureTypeByName(name: StructureTypeName): GetStructureTypeByName {
	const [id, entry] = Object.entries(structureType).find(([, s]) => s.name === name)!;

	return {
		id: id as Dryp.StructureTypeId,
		...entry,
	};
}
